export default "<div id=\"StorePage\">\n    Die OC-Ar Viewer App finden sie im Apple Appstore.\n</div>";